import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export enum AnalyticsEventType {
  CertificationViewsCourseCompletion = 'certification - views course completion',
  CertificationViewsDetails = 'certification - views details',
  CertificationClicksVerifiableCredentials = 'certification - clicks verifiable credentials',
  CertificationViewsShare = 'certification - views share',
  CertificationClicksShareFacebook = 'certification - clicks share - facebook',
  CertificationClicksShareTwitter = 'certification - clicks share - twitter',
  CertificationClicksShareCredivera = 'certification - clicks share - credivera',
  CertificationClicksShareLinkedIn = 'certification - clicks share - linkedin',
  CertificationExportDigitalBadge = 'certification - export digital badge',
  CertificationExportWalletCard = 'certification - export wallet card',
  CertificationExportWallCertificate = 'certification - export wall certificate',
  VCInitCourse = 'VC - init course',
  VCInitCertification = 'VC - init certification'
}

export class AnalyticsEvent extends Event {
  eventType: AnalyticsEventType;
  eventProperties: object;

  constructor(type: AnalyticsEventType, props: object = null) {
    super('analytics:event');
    this.eventType = type;
    this.eventProperties = props;
  }
}

@Injectable({
  providedIn: 'root'
})
export class AnalyticsEventsService {
  events$ = new Subject<AnalyticsEvent>();

  // publish an event
  publish(event: AnalyticsEvent) {
    this.events$.next(event);
  }

  // build and publish an event
  trigger(type: AnalyticsEventType, props?: object) {
    this.publish(new AnalyticsEvent(type, props));
  }
}
